<template>
  <section class="page-container">
    <div class="flex-sb-center">
      <h1>Renewal</h1>
      <v-button
        v-if="!['quote'].includes(active)"
        :disabled="date == ''"
        gray
        @click="handleExport">Export Excel</v-button>
    </div>
    <div class="header ">
      <el-tabs
        v-model="active"
        class="mg-b-15"
        @tab-click="changeTab">
        <el-tab-pane
          v-for="(tab, index) in tabList"
          :key="index"
          :label="tab.label"
          :name="tab.name"
        ></el-tab-pane>
      </el-tabs>
      <div class="mg-b-30 flex-sb-center">
        <v-radio-group
          v-model="filter.merchant_platform"
          button
          :list="serverTypeOption"
          @change="filterData"></v-radio-group>
        <div
          v-if="['mailStatus'].includes(active)"
          class="flex">
          <v-button
            gray
            :disabled="downList.length<=0"
            icon="print"
            @click="handleDown">Print Out</v-button>
          <v-button
            green
            :disabled="statusList.length<=0"
            @click="handleChangeStatus"
          >Change Mail Status <span v-if="statusList.length>0">({{statusList.length}})</span></v-button>
        </div>
      </div>
    </div>

    <div class="search">
      <v-input
        v-model="filter.search"
        :prefixIcon="'el-icon-search'"
        :placeholder="placeholder"
        @keyEnter="filterData"/>

    </div>
    <div class="filter-card">
      <div class="filter">
        <div class="filter-left">
          <div class="form-item">
            <span v-if="active == 'renew'">Expected Effective Date</span>
            <span v-else>End Date</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="filterData" />
          </div>
          <div class="form-item">
            <span>Insurer</span>
            <span>
              <v-select
                v-model="filter.company_id"
                :list="companyList"
                @change="filterData" />
            </span>
          </div>
          <div
            v-if="!isMailStatus"
            class="form-item">
            <span>
              Referrer
            </span>
            <span>
              <v-input
                v-model="filter.referrer_code"
                @change="filterData" />
            </span>
          </div>
        </div>
        <div class="filter-middler border-right">
          <div class="form-item">
            <span>
              Product Type
              <span
                class="all blue mg-l-5 pointer"
                @click="handlerSelectAll('class_id')"> All</span>
              <span
                class="all  blue mg-l-10 pointer"
                @click="handlerNoneAll('class_id')">None</span>
            </span>
            <div class="flex">
              <div class="half">
                <span>Auto-Quote</span>
                <v-checkbox
                  v-model="motor_select"
                  class="mg-t-8 mg-b-10"
                  :is-indeterminate="isAllMotorSelect"
                  @change="handleSelectQuote"><span class="fs-14 color-dark fw-600">Motors</span></v-checkbox>
                <v-checkbox-group
                  v-model="class_id"
                  :list="motorClassOptions"
                  :isColumn="false"
                  @change="filterData"></v-checkbox-group>
                <v-checkbox
                  v-model="none_motor_select"
                  class="mg-t-8 mg-b-10"
                  :is-indeterminate="isNoneMotorSelect"
                  @change="handleSelectNoneQuote"><span class="fs-14 color-dark fw-600">Non-Motors</span></v-checkbox>
                <v-checkbox-group
                  v-model="class_id"
                  :list="noneMotorClassOptions"
                  :isColumn="false"
                  @change="filterData"></v-checkbox-group>
              </div>
              <div class="half">
                <span>SME</span>
                <v-checkbox-group
                  v-model="class_id"
                  :list="sme_class_data"
                  :isColumn="false"
                  @change="filterData"></v-checkbox-group>
              </div>
              <!--              <div class="half">-->
              <!--                <span>SME</span>-->
              <!--                <v-checkbox-group-->
              <!--                  v-model="product_id"-->
              <!--                  :list="ticketOptions.categoryOptions"-->
              <!--                  :block="true"-->
              <!--                  @change="filterData"></v-checkbox-group>-->
              <!--              </div>-->
              <!-- <div class="half">
                <span>&nbsp;</span>
                <v-checkbox-group
                  v-model="product_id"
                  :list="ticketOptions.industryOptions"
                  :block="true"
                  @change="filterData"></v-checkbox-group>
              </div> -->
            </div>
          </div>
        </div>
        <div
          class="filter-right border-right">
          <div class="form-item">
            <span>
              Consent
            </span>
            <v-checkbox-group
              v-model="filter.pcy_agreement_1"
              :list="user_agreement_option"
              :block="isMailStatus||isBlock"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="fs-12"
                    :class="{
                      'pending_verify-color': item.id ==0,
                      'verified-color': item.id == 1,
                      'gray': item.id == -1,
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
        </div>
        <div
          v-if="!isMailStatus"
          class="filter-right border-right"
          :class="{'border-right':isBlock||isMailStatus}">
          <div class="form-item">
            <span>
              Auto Renew
            </span>
            <v-checkbox-group
              v-model="filter.auto_renewal_tag"
              :list="auto_renewal_tag_list "
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="span-options fs-12"
                    :class="{
                      'gold': [2].includes(item.id),
                      'blue': [4].includes(item.id),
                      'black': [1].includes(item.id),
                      'red': [3].includes(item.id),
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
          <div class="form-item">
            <span>
              Client Option</span>
            <v-checkbox-group
              v-model="filter.auto_renewal"
              :list="auto_renewal_list"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="span-options-2 fs-12"
                    :class="{
                      'black': item.id === 2,
                      'green': item.id === 1
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
        </div>
        <div
          v-if="isMailStatus"
          class="filter-right flex-last flex border-right">
          <div class="form-item">
            <span>
              Mail Status
            </span>
            <v-checkbox-group
              v-model="filter.stts"
              :list="renew_mail_status"
              block
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="fs-12"
                    :class="{
                      'pending_verify-color': item.id ==1,
                      'color-dark': item.id == 4,
                      'verified-color': item.id == 3,
                      'purple': item.id == 2,
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
          <div class="form-item">
            <span>
              Renew
            </span>
            <v-checkbox-group
              v-model="filter.no_need"
              :list="renew_list"
              block
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="fs-12"
                    :class="{
                      'color-dark': item.id == 0,
                      'orange': item.id === 1,
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <unquote-list
      v-if="active == 'unquote'"
      ref="unquote"
      :filterData="filter"></unquote-list>
    <quote-list
      v-if="active == 'quote'"
      ref="quote"
      :filterData="filter"></quote-list>
    <renew-list
      v-if="active == 'renew'"
      ref="renew"
      :filterData="filter"></renew-list>
    <mail-renew-status-list
      v-if="active == 'mailStatus'"
      ref="mailStatus"
      :statusList.sync="statusList"
      :downList.sync="downList"
      :filterData="filter"></mail-renew-status-list>
  </section>
</template>

<script>
import UnquoteList from './components/unquote-list'
import QuoteList from './components/quote-list'
import RenewList from './components/renew-list'
import mailRenewStatusList from './components/mail-renew-status-list'
import {mapActions,mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinProductTypeFilter from '@/mixins/product-type-filter'

export default {
  name: 'Policy',
  components:{
    UnquoteList,
    QuoteList,
    RenewList,
    mailRenewStatusList
  },
  mixins: [MixinOptions,MixinProductTypeFilter],
  data() {
    return{
      active: 'unquote',
      tabList:[
        {
          name: 'unquote',
          label: 'Unquoted Policies'
        },
        {
          name: 'quote',
          label: 'Quoted Policies'
        },
        {
          name: 'renew',
          label: 'Renew Quotes'
        },
        {
          name: 'mailStatus',
          label: 'Mail Status'
        },
      ],
      date: '',
      filter:{
        search: '',
        start_dt: '',
        merchant_platform: '',
        end_dt: '',
        company_id: 0,
        referrer_code: '',
        pcy_agreement_1: [],
        auto_renewal_tag: [],
        auto_renewal: [],
        class_id: [],
        stts: [1],
        no_need: [0]
      },
      statusList:[],
      downList:[],
      renew_status:[0]
    }
  },
  computed: {
    ...mapState('renewal', ['activeTab', 'getfilterData']),
    ...mapState('common', ['specialOptions']),
    placeholder() {
      if (this.active == 'mailStatus') {
        return 'Policy No., HCID, Quote No., Policyholder: Name/Contact/ ID No./ VRD , Referrer'
      } else if (!['renew', 'mailStatus'].includes(this.active)) {
        return 'Policy No., Cover Note No., HCID, Endorsement No., Customer Name, Contact, Referrer, VRD'
      } else {
        return 'ID,Customer Name,Contact,Referrer Name,Price'
      }
    },
    isBlock() {
      return ['unquote', 'quote'].includes(this.active)
    },
    companyList() {
      let list = JSON.parse(JSON.stringify(this.insurerAllOptions))
      list.unshift({id: 0, name: 'All'})
      return list
    },
    classList() {
      let list = JSON.parse(JSON.stringify(this.specialOptions.renew_product_type))
      list.unshift({id: 0, name: 'All'})
      return list
    },
    renew_mail_status(){
      let {renew_mail_status} = this.globalOptions
      return renew_mail_status||[]
    },
    renew_list(){
      return [
        {
          id:0,
          name:'Need'
        },
        {
          id:1,
          name:'No Need'
        }
      ]
    },
    isMailStatus(){
      return this.active == 'mailStatus'
    },
    filterParams(){
      return {...this.filter,class_id:this.class_id}
    }
  },
  watch:{
    activeTab:{
      immediate: true,
      handler(val) {
        if(val){
          this.active =val
        }
      }
    },
    getfilterData:{
      immediate: true,
      deep: true,
      handler(val){
        if(val && Object.keys(val).length){
          this.filter = val
          if(val.start_dt && val.end_dt){
            this.date = []
            this.date.push(val.start_dt)
            this.date.push(val.end_dt)
          }
        }
      }
    }
  },
  beforeDestroy(){
    this.setFilterData(this.filter)
  },
  methods: {
    ...mapActions('renewal',['setActiveTab', 'setFilterData']),
    handleChangeStatus(){
      this.$refs.mailStatus.handleChangeStatus()
    },
    handleDown(){
      this.$refs.mailStatus.handleMoreDown({download_id:this.downList})
    },
    handlerSelectAll(target) {
      let origin = ''
      switch(target) {
        case 'class_id':
          origin = 'all_class_data'
          break
      }
      const data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this[target] = data
      this.filterData()
    },
    handlerNoneAll(target){
      this[target] = []
      if(target=='class_id')
        this.filter.class_id = []
      this.filterData()
    },
    handlerFilter(name, option) {
      const data = this[option].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this[name] = data
      this.filterData()
    },
    changeTab(){
      this.setActiveTab(this.active)
      this.clearFilter()
    },

    clearFilter(){
      this.date = []
      this.filter.start_dt = ''
      this.filter.end_dt = ''
      this.filter.company_id = 0
      this.filter.class_id = []
      this.filter.search = ''
      this.filter.pcy_agreement_1 = []
    },

    filterData(){
      if(this.date && this.date.length > 0){
        this.filter.start_dt = this.date[0]
        this.filter.end_dt = this.date[1]
      }else{
        this.filter.start_dt = null
        this.filter.end_dt = null
      }
      console.log('this.class_id-',this.class_id)
      this.filter.class_id = this.class_id
      this.$refs[this.active].pageConfig.currentPage = 1
      this.$refs[this.active].network().getRenewalList()
    },

    handleExport(){
      this.$refs[this.active].network().getRenewalList({
        is_export: 1
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.header{
  position: relative;
  .export-btn{
    position: absolute;
    right: 0;
    top: 0;
  }
}
.search {
  font-weight: 600;
  margin-bottom: 20px;
}
.verified-color{
  color: #22863a;
}
.pending_verify-color{
  color: #dbab09;
}
.purple{
  color: #6F42C1;

}
.black {
  color: #24292E;
}
.filter-card{
  margin-bottom: 15px;
  background: white;
  border: 1px solid #E1E4E8;
  border-radius: 5px;
  .filter {
    display: flex;
    padding: 0 15px;
    background: white;
    border-radius: 5px;
    .filter-left, .filter-middler, .filter-right {
      padding: 15px 0;
      //width: 200px;
    }
    .filter-left {
      padding-right: 10px;
      flex: 3;
      flex-wrap: wrap;
      .form-item{
        width: 200px;
        margin-right: 15px;
      }
    }
    .filter-middler {
      padding: 15px 10px;
    }
    .filter-right {
      padding-left: 15px;
      flex: 1;

    }
    .border-right{
      border-left: 1px solid #E1E4E8;
    }
    .flex-last{
      flex: 2;
    }
  }
}

.span-options{
  display: inline-block;
  padding: 0px 8px;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #FFFFFF;
  border-radius: 100px;
  max-width: 140px;
  word-break:keep-all;
  white-space:nowrap;
  height: 18px;
  border: 1px solid;
  &__none{
    border: none;
  }
  &.gray {
    border-color: #586069;
    color: #586069;
  }
  &.green {
    border-color: #22863A;
    color: #22863A;
  }
  &.red {
    border-color: #D73A49;
    color: #D73A49;
  }
  &.gold {
    border-color: #735C0F;
    color: #735C0F;
  }
  &.blue {
    border-color: #0366D6;
    color: #0366D6;
  }
  &.orange {
    border-color: #C24E00;
    color: #C24E00;
  }
  &.black {
    border-color: #24292E;
    color: #24292E;
  }
  &.yellow-dark {
    border-color: #DBAB09;
    color: #DBAB09;
  }
}
.orange{
  color: #C24E00;
}
.half{
   span{
    display: block;
    padding-bottom: 5px;
    font-size: 14px;
    color: #6a737d;
  }
}
</style>
